import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Input from "../../../../components/inputs/inputs";
import { Beat } from "../../../../plugins/spinners.plugin";
import SelectableInput from "../../../../components/inputs/SelectableInput";
import {
  // getAllTags,
  filterProductTag,
} from "../../../../redux/productTags/productTagActions";
import {
  // getAllCategories,
  filterProductCategory,
} from "../../../../redux/productCatergory/productCategoryAction";

export default function OnboardRestaurant({
  handleChange,
  data,
  setData,
  handleSubmit,
  handleBack,
  submitted,
  Location,
  locationId,
  locationList,
  setLocationList,
  setLocationId,
  restaurant_phone,
  setRestaurantPhone,
  handleRegion,
}) {
  const dispatch = useDispatch();
  const toJson = (value) => JSON.stringify(value);
  const fromJson = (value) => JSON.parse(value);
  const {
    restaurant_name,
    restaurant_email,
    restaurant_address,
    restaurant_city,
    restaurant_state,
    restaurant_country,
    restaurant_description,
    restaurant_categories,
    restaurant_tags,
  } = data;

  useEffect(() => {
    // dispatch(getAllTags());
    dispatch(filterProductTag({ type: "restaurant" }, 1));
    // dispatch(getAllCategories());
    dispatch(filterProductCategory({ type: "restaurant" }, 1));
    // eslint-disable-next-line
  }, []);

  const [restaurantCategories, setRestaurantCategories] = useState([]);
  const [restaurantTags, setRestaurantTags] = useState([]);
  const { allTags } = useSelector((state) => state.productTag);
  const { allCategories } = useSelector((state) => state.productCatergory);
  const { isLoading } = useSelector((state) => state.onboard);
  console.log("allTags", allTags);

  useEffect(() => {
    const restaurantCategories = allCategories?.data?.filter((item) => {
      return item?.type === "restaurant";
    });
    setRestaurantCategories(restaurantCategories);
    // eslint-disable-next-line
  }, [allCategories]);

  useEffect(() => {
    const restaurantTags = allTags?.data?.filter((item) => {
      return item?.type === "restaurant";
    });
    setRestaurantTags(restaurantTags);
    // eslint-disable-next-line
  }, [allTags]);
  console.log("restaurantTags", restaurantTags);

  const handleAddTags = (value) => {
    const former_tags = [...data?.restaurant_tags];
    let new_tags = [...former_tags, value.name];
    setData({ ...data, restaurant_tags: new_tags });
  };

  const handleAddCategories = (value) => {
    const former_categories = [...data?.restaurant_categories];
    let new_categories = [...former_categories, value.name];
    setData({ ...data, restaurant_categories: new_categories });
  };

  return (
    <div>
      <div
        className="pt-4 sm:pt-2 sm:flex items-center mx-auto mb-4"
        data-test="businessComponent"
      >
        <div className=" max-w-4xl mx-auto mt-10">
          <div className="sm:w-[629px] w-full mt-10 sm:ml-10 sm:mt-0 sm:border px-6 sm:border-gray-200">
            <form
              name="form "
              id="business-form"
              onSubmit={(e) => handleSubmit(e)}
            >
              <p>fffff</p>
              <div className="border-b-2 py-4 mb-6">
                <p className=" text-base font-medium text-gray-800 flex justify-center ">
                  Restaurant Details
                </p>
              </div>
              <div className=" sm:px-10">
                <div
                  className={
                    "mt-4" +
                    (submitted && restaurant_name ? " border-red-500" : "")
                  }
                >
                  <Input.Label
                    title={"Restaurant Name "}
                    htmlFor={"restaurant_name"}
                    type={"text"}
                    value={restaurant_name}
                    name={"restaurant_name"}
                    onChange={handleChange}
                    placeholder={"Enter restaurant name"}
                  />
                </div>
                <div
                  className={
                    "mt-4" +
                    (submitted && restaurant_email ? " border-red-500" : "")
                  }
                >
                  <Input.Label
                    title={"Restaurant Email *"}
                    htmlFor={"restaurant_email"}
                    type={"email"}
                    name={"restaurant_email"}
                    onChange={handleChange}
                    placeholder={"Enter restaurant email address"}
                  />
                </div>
                <div
                  className={
                    "mt-4" +
                    (submitted && restaurant_phone ? " border-red-500" : "")
                  }
                >
                  <Input.Phone
                    defaultCountry="NG"
                    title={"Restaurant Phone Number"}
                    htmlFor={"restaurant_phone"}
                    value={restaurant_phone}
                    onChange={setRestaurantPhone}
                    placeholder={"Enter phone number"}
                  />
                </div>
                <div
                  className={
                    "mt-4" +
                    (submitted && restaurant_address ? " border-red-500" : "")
                  }
                >
                  <Input.Label
                    title={"Restaurant Address *"}
                    htmlFor={"restaurant_address"}
                    value={restaurant_address}
                    type={"text"}
                    name={"restaurant_address"}
                    onChange={handleChange}
                    placeholder={"Enter Restaurant Address"}
                  />
                </div>
                <div
                  className={
                    "mt-4" +
                    (submitted && restaurant_description
                      ? " border-red-500"
                      : "")
                  }
                >
                  <Input.TextArea
                    title={"Restaurant Description "}
                    htmlFor={"restaurant_description"}
                    value={restaurant_description}
                    type={"text"}
                    name={"restaurant_description"}
                    onChange={handleChange}
                    placeholder={"Describe your restaurant to us"}
                  />
                </div>

                {/* <div
                  className={
                    submitted && !restaurant_categories
                      ? "  border-red-500"
                      : ""
                  }
                >
                  <div className="mt-2">
                    <Input.Select
                      title={"Restaurant Category*"}
                      htmlFor={"restaurant_categories"}
                      name={"restaurant_categories"}
                      id={"restaurant_categories"}
                      onChange={handleChange}
                      className={
                        "mt-2 block pl-3 pr-10 w-full text-base bg-[#FFFFFF] focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm rounded-sm h-[40px] px-4 py-2 mb-4 border border-gray-300"
                      }
                    >
                      <option>Select a restaurant category</option>
                      {restaurantCategories?.map((category, i) => (
                        <option key={i} value={category.name}>
                          {category.name}
                        </option>
                      ))}
                    </Input.Select>

                    {submitted && !restaurant_categories && (
                      <div className="text-primary text-xs ">
                        Restaurant category is required
                      </div>
                    )}
                  </div>
                </div> */}

                <div
                  className={
                    "mt-4" +
                    (submitted && restaurant_categories
                      ? " border-red-500"
                      : "")
                  }
                >
                  <label
                    htmlFor="restaurant_categories"
                    className="text-sm font-medium text-[#151515]"
                  >
                    Restaurant Categories*
                  </label>
                  <SelectableInput
                    options={restaurantCategories}
                    label="restaurant_categories"
                    name={"+ Add Category"}
                    type="category"
                    selectOption={handleAddCategories}
                  />
                </div>

                <div
                  className={
                    "mt-4" +
                    (submitted && restaurant_tags ? " border-red-500" : "")
                  }
                >
                  <label
                    htmlFor="restaurant_tags"
                    className="text-sm font-medium text-[#151515]"
                  >
                    Restaurant Tags*
                  </label>
                  <SelectableInput
                    options={restaurantTags}
                    label="restaurant_tags"
                    name={"+ Add Tag"}
                    type="tag"
                    selectOption={handleAddTags}
                  />
                </div>

                <Location
                  country_id={locationId.country_id}
                  state_id={locationId.state_id}
                  city_id={locationId.city_id}
                  countryList={(value) => {
                    setLocationList({
                      ...locationList,
                      countryList: value,
                    });
                  }}
                  stateList={(value) => {
                    setLocationList({ ...locationList, stateList: value });
                  }}
                  cityList={(value) => {
                    setLocationList({ ...locationList, cityList: value });
                  }}
                />
                <div
                  className={
                    "mt-4" +
                    (submitted && restaurant_country ? " border-red-500" : "")
                  }
                >
                  <label
                    htmlFor="restaurant_country"
                    className="text-sm font-medium text-[#151515]"
                  >
                    Country*
                  </label>
                  <select
                    name="restaurant_country"
                    className="mt-2 block w-full pl-3 pr-10 text-base bg-[#FFFFF] focus:outline-none focus:ring-2 focus:ring-red-600  focus:border-red-600 sm:text-sm rounded-sm h-[40px] px-4 py-2 mb-4 border border-gray-300"
                    onChange={(e) => {
                      setLocationId({
                        ...locationId,
                        country_id: fromJson(e.target.value).id,
                      });
                      handleRegion(e);
                    }}
                  >
                    <option>
                      {restaurant_country
                        ? restaurant_country
                        : "Select country"}
                    </option>

                    {locationList.countryList &&
                      locationList.countryList.length > 0 &&
                      locationList.countryList.map((item, key) => {
                        return (
                          <option
                            key={key}
                            value={toJson({ name: item.name, id: item.id })}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>

                  {/* {submitted && !restaurant_country && (
                    <div className=" text-xs text-red-500">
                      Restaurant country is required
                    </div>
                  )} */}
                </div>
                <div
                  className={
                    "mt-4" +
                    (submitted && restaurant_state ? " border-red-500" : "")
                  }
                >
                  <label
                    htmlFor="restaurant_state"
                    className="text-sm font-medium text-[#151515]"
                  >
                    {" "}
                    State{" "}
                  </label>
                  <select
                    name="restaurant_state"
                    className="mt-2 block w-full pl-3 pr-10 text-base  bg-[#FFFFF] focus:outline-none focus:ring-2 focus:ring-red-600  focus:border-red-600 sm:text-sm rounded-sm h-[40px] px-4 py-2 mb-4 border border-gray-300"
                    onChange={(e) => {
                      setLocationId({
                        ...locationId,
                        state_id: fromJson(e.target.value).id,
                      });
                      handleRegion(e);
                    }}
                  >
                    <option>
                      {restaurant_state ? restaurant_state : "Select state"}
                    </option>

                    {locationList.stateList &&
                      locationList.stateList.length > 0 &&
                      locationList.stateList.map((item, key) => {
                        return (
                          <option
                            key={key}
                            value={toJson({ name: item.name, id: item.id })}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {/* {submitted && !restaurant_state && (
                    <div className="text-xs text-red-500">
                      Restaurant state is required.
                    </div>
                  )} */}
                </div>
                <div
                  className={
                    "mt-4 mb-16" +
                    (submitted && restaurant_city ? " border-red-500" : "")
                  }
                >
                  <label
                    htmlFor="restaurant_city"
                    className="text-sm font-medium text-[#151515]"
                  >
                    {" "}
                    City{" "}
                  </label>
                  <select
                    name="restaurant_city"
                    className="mt-2 block w-full pl-3 pr-10 text-base  bg-[#FFFFF] focus:outline-none focus:ring-2 focus:ring-red-600  focus:border-red-600 sm:text-sm rounded-sm h-[40px] px-4 py-2 mb-4 border border-gray-300"
                    onChange={(e) => {
                      setLocationId({
                        ...locationId,
                        city_id: fromJson(e.target.value).id,
                      });
                      handleRegion(e);
                    }}
                  >
                    <option>
                      {restaurant_city ? restaurant_city : "Select a city"}
                    </option>
                    {locationList.cityList &&
                      locationList.cityList.length > 0 &&
                      locationList.cityList.map((item, key) => {
                        return (
                          <option
                            key={key}
                            value={toJson({ name: item.name, id: item.id })}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {/* {submitted && !restaurant_city && (
                    <div className="text-xs text-red-500">
                      Restaurant city is required.
                    </div>
                  )} */}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="sm:flex sm:justify-between sm:mt-10 sm:max-w-[800px] sm:mb-5 mx-auto">
        <button
          onClick={handleBack}
          className="rounded-md w-[333px] sm:mt-10 mx-auto  flex justify-center mb-5 sm:mb-0 shadow-sm px-3 py-3 border border-primary text-primary text-base font-medium bg-white  sm:text-sm"
        >
          Back
        </button>

        <button
          form="business-form"
          type="submit"
          className=" rounded-md w-[333px] sm:mt-10 mx-auto flex justify-center shadow-sm px-4 py-3  bg-primary text-base font-medium text-white hover:bg-red-700  sm:text-sm"
        >
          {isLoading ? <Beat color={"#ffffff"} /> : "Submit"}
        </button>
      </div>
    </div>
  );
}
